import React from "react";
import PropTypes from "prop-types";
// import css from 'cape-style'
import ReactPlayer from "react-player";
import { VideoContainer } from "./styles";

// function getSrc(provider, url) {
//   let src = "";
//   switch (provider) {
//     case "Vimeo":
//       src = `https://player.vimeo.com/video${url.pathname}`;
//       break;
//     case "YouTube":
//       src = `https://www.youtube.com/embed/${url.query.v}`;
//       break;
//     default:
//       break;
//   }
//   return src;
// }

function Video({ provider, url, ...rest }) {
  // const src = getSrc(provider, url);
  return (
    <VideoContainer>
      {/* <iframe {...rest} src={src} /> */}
      <ReactPlayer
        className="player"
        url={url}
        width="100%"
        height="100%"
        light
      />
    </VideoContainer>
  );
}

Video.propTypes = {
  provider: PropTypes.string,
  // url: PropTypes.shape({
  //   pathname: PropTypes.string,
  //   query: PropTypes.object,
  // }).isRequired,
  url: PropTypes.string.isRequired,
};
Video.defaultProps = {
  frameBorder: "0",
  allowFullScreen: true,
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/StudentDetail/Video.jsx